export default __webpack_public_path__ + "static/media/yoga.a58f0441.svg";